import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { InvoiceAnalysisComponent } from './invoice.analysis.component';
import { InvoiceModel }             from './models/invoice';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  private _statuses = {
    open     : 'O',
    closed   : 'C',
    processed: 'P'
  };

  private _types = {
    credit  : 'C',
    quote   : 'Q',
    invoice : 'I',
    internal: 'U'
  };

  constructor (
    private modalService: NgbModal
  ) {}

  isStatus ( invoice : InvoiceModel, status : string ) : boolean {
    if (status === 'actionable') {
      return (this.isType(invoice, 'credit') && this.isStatus(invoice, 'processed')) ||
        invoice.customer_id && this.isType(invoice, 'quote') ||
        (invoice.customer_id && (invoice.repco || invoice.ashdown || invoice.prolink) );
    }

    return this._statuses[status] === invoice.invoice_status;
  }

  isType ( invoice : InvoiceModel, type : string ) : boolean {
    return this._types[type] === invoice.invoice_type;
  };

  viewAnalysis ( invoice : InvoiceModel ) : void {
    const modal = this.modalService.open(InvoiceAnalysisComponent, {
      windowClass: 'x-lg-modal'
    });

    modal.componentInstance.invoice = invoice;
  }
}
